module.exports = __webpack_public_path__ + "assets/pdf/Gemeinwohl-Fokusbericht - Die Webmacherin.fa1902a8.pdf";